import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api';

export interface PublicAppConfig {
  maxHintsForStudent: number;
}

const FALLBACK: PublicAppConfig = {
  maxHintsForStudent: 3,
};

const STALE_TIME = 10 * 60 * 1000;

export function useAppConfig(): PublicAppConfig {
  const { fetchApi } = useApi();
  const { data } = useQuery({
    queryKey: ['app-config'],
    queryFn: () => fetchApi<PublicAppConfig>('/app-config'),
    staleTime: STALE_TIME,
  });
  return data ?? FALLBACK;
}
